<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="remesaForm" @submit.prevent="registrarRemesa">
          <v-row>
            <v-col cols="4">
              <v-select
                class="ui-form-field"
                v-model="remesa.fk_idLoc"
                :items="locOptions"
                item-value="idLoc"
                item-text="displayText"
                rounded
                filled
                dense
                background-color="transparent"
                color="secondary"
              >
                <template v-slot:label>ID Loc´s</template>
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaAlta"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="ui-form-field"
                    v-model="fechaAltaFormatted"
                    label="Fecha alta"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato de fecha: DD/MM/YYYY"
                  />
                </template>
                <v-date-picker
                  v-model="remesa.fechaAlta"
                  @input="menuFechaAlta = false"
                  locale="es"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaTramite"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="ui-form-field"
                    v-model="fechaTramiteFormatted"
                    label="Fecha de trámite"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato de fecha: DD/MM/YYYY"
                  />
                </template>
                <v-date-picker
                  v-model="remesa.fechaTramite"
                  @input="menuFechaTramite = false"
                  locale="es"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <BaseInput
                class="ui-form-field"
                v-model="remesa.numOficio"
                label="Numero de oficio"
                background-color="transparent"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center ui-module-actions">
      <TextButton class="ui-module-btn-solid" :loading="loading" @click="registrarRemesa">
        Registrar Remesa
      </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import BaseSelect from '@/components/base/BaseSelect.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import TextButton from '@/components/base/TextButton.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BaseSelect,
    BaseInput,
    TextButton,
  },
  data() {
    return {
      remesaForm: false,
      loading: false,
      menuFechaAlta: false,
      menuFechaTramite: false,
      remesa: {
        fk_idLoc: 0,
        fechaAlta: '',
        fechaTramite: '',
        numOficio: '',
      },
    }
  },
  computed: {
    ...mapGetters('licenciaOficialColectiva', {
      locs: 'getLocs',
    }),
    locOptions() {
      return this.locs.map((loc) => ({
        idLoc: loc.idLoc,
        displayText: `${loc.noLicencia}`,
      }))
    },
    fechaAltaFormatted() {
      return this.remesa.fechaAlta ? moment(this.remesa.fechaAlta, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    },
    fechaTramiteFormatted() {
      return this.remesa.fechaTramite ? moment(this.remesa.fechaTramite, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    },
  },
  methods: {
    ...mapActions('remesas', ['createRemesa']),
    ...mapActions('licenciaOficialColectiva', {
      fetchLocs: 'fetchLocs',
    }),
    limpiarFormulario() {
      this.remesa = {
        fk_idLoc: 0,
        fechaAlta: '',
        fechaTramite: '',
        numOficio: '',
      }
      this.$refs.form && this.$refs.form.resetValidation()
    },
    async registrarRemesa() {
      this.loading = true
      try {
        const payload = {
          ...this.remesa,
          fechaAlta: this.remesa.fechaAlta ? moment(this.remesa.fechaAlta, 'YYYY-MM-DD').format('YYYY-MM-DD') : '',
          fechaTramite: this.remesa.fechaTramite
            ? moment(this.remesa.fechaTramite, 'YYYY-MM-DD').format('YYYY-MM-DD')
            : '',
        }
        await this.createRemesa(payload)
        this.limpiarFormulario()
        this.$emit('close')
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchLocs()
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down,
::v-deep .ui-form-field .mdi-calendar {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field .v-messages__message,
::v-deep .ui-form-field .v-text-field__details {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}
</style>
